<template>
  <table-component
    v-if="mixin.loaded"
    :content="cases"
    :headings="headings"
    :item_keys="item_keys"
    :display_spec="caseSpecs"
    :empty_message="'The customer has no cases.'">
  </table-component>
  <!-- Loader -->
  <loader-component v-else></loader-component>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { caseSpecs } from '@/display_context/display_context'
  import { loadItemsMixin } from '@/mixins/mixins'
  import TableComponent from '@/components/layout/table/TableComponent'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'customer-case-view',
    mixins: [loadItemsMixin],
    components: {
      TableComponent,
      LoaderComponent
    },
    data () {
      return {
        headings: ['Case number', 'Certification', 'Status', 'Created', 'Updated', 'Responsible'],
        item_keys: ['caseLink', 'service.code', 'state', 'created', 'modified', 'responsible.profileTypeDisplay'],
        caseSpecs: caseSpecs,
        mixin: { actionMethod: this.getCases }
      }
    },
    computed: {
      ...mapState({
        cases: state => state.caseModule.cases
      })
    },
    methods: {
      ...mapActions([
        'getCases'
      ])
    }
  }
</script>
